<template>
  <VTooltip
    :theme="theme"
    :placement="placement"
    :popperClass="className"
    :triggers="hoverable ? ['hover', 'focus'] : undefined"
    :popperTriggers="hoverable ? ['hover', 'focus'] : undefined"
    :delay="hoverable ? { show: 0, hide: 200 } : undefined"
  >
    <button
      type="button"
      class="custom-clue-tooltip-trigger"
      aria-label="Show information tooltip"
    >
      <icon
        data="@icon/info-tooltip.svg"
        :width="size"
        :height="size"
        :color="color"
        class="custom-clue-tooltip-icon"
      />
    </button>
    <template #popper>
      <slot>
        <span v-html="text" />
      </slot>
    </template>
  </VTooltip>
</template>

<script setup lang="ts">
defineProps({
  text: {
    type: String,
    default: ""
  },
  size: {
    type: String,
    default: "16"
  },
  className: {
    type: String,
    default: ""
  },
  placement: {
    type: String,
    default: "top"
  },
  theme: {
    type: String,
    default: "info-tooltip"
  },
  color: {
    type: String,
    default: "var(--monochrome05to04)"
  },
  hoverable: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped lang="scss">
.custom-clue-tooltip-trigger {
  display: inline-flex;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
</style>
